import {Component} from '@angular/core';

@Component({
    selector: 'app-sidebar-form',
    standalone: true,
    template: ``,
        imports: []
})
export class AppSidebarFormComponent {

    constructor() {
    }
}